import Permission from "../Permission";
import {useMemo} from "react";

interface Props {
    permissions: string[];
    onChange: (permissions: string[]) => void;
    server: string;
}

interface Permissions {
    name: string;
    description: string;
    possibleValues: {
        value: string;
        permissions: string[];
    }[];
}

export default function ServerPermissions({permissions, onChange, server}: Props) {

    const permissionsList = useMemo(() => {
        return [
            {
                name: 'Servers',
                description: 'Permissions related to server management.',
                possibleValues: [
                    {value: 'none', permissions: []},
                    {value: 'read', permissions: [`server.${server}.read`]},
                    {value: 'write', permissions: [`server.${server}.read`, `server.${server}.write`]},
                ]
            },
        ];
    }, [server])

    return <>
        {permissionsList.map((permission) => {
            let value = undefined;
            let score = 0;

            for (const p of permission.possibleValues) {
                if (p.permissions.every(perm => permissions.includes(perm))) {
                    const tvalue = p.value;
                    const tscore = p.permissions.length;
                    if (value === undefined || tscore > score) {
                        value = tvalue;
                        score = tscore;
                    }
                }
            }

            return <Permission
                key={permission.name}
                permission={permission.name}
                description={permission.description}
                possibleValues={permission.possibleValues.map(value => value.value)}
                value={value ?? 'none'}
                setPermission={(value: string) => {
                    const newPermissions = permission.possibleValues.find(v => v.value === value)?.permissions || [];
                    const allPermissions: string[] = [];
                    for (const p of permission.possibleValues) {
                        allPermissions.push(...p.permissions);
                    }
                    const filteredPermissions = permissions.filter(p => !allPermissions.includes(p));
                    onChange([...filteredPermissions, ...newPermissions]);

                }}
            />
        })}
    </>

}
